import Vue from 'vue';
import VueRouter from 'vue-router';
import VueFilter from 'vue-filter';
import VueMoment from 'vue-moment';
import ElementUI from 'element-ui';
import MaskedInput from 'vue-text-mask';
import VueProgressBar from 'vue-progressbar';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import 'bootstrap-sass/assets/javascripts/bootstrap.min';
import 'jquery';
import App from './App.vue';
import SidebarMenu from './components/SidebarMenu.vue';
import TopbarMenu from './components/TopbarMenu.vue';
import router from './router/router';
import './js/theme';
import style from './scss/all.scss';// eslint-disable-line no-unused-vars
import store from './store';
import currency from './filters/currency';
import capitalize from './filters/capitalize';
import number from './filters/number';

require('font-awesome-sass-loader');
require('./assets/favicon.png');

if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = (err, vm, info) => {
    // Log properties passed to the component if there are any
    if (vm.$options.propsData) {
      console.log('Props passed to component', vm.$options.propsData);
    }
    // Emit component name and also the lifecycle hook the error occured in if present
    let infoMessage = `Error in component: <${vm.$options.name} />\n`;
    if (info) {
      infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
    }
    // This puts the additional error information in the Telemetry Timeline
    console.log(infoMessage);

    // Track the native JS error
    trackJs.track(err); // eslint-disable-line
  };
}

const ProgressBarOptions = {
  color: '#1ABB9C',
  failedColor: '#874b4b',
  thickness: '3px',
  autoRevert: true,
  location: 'top',
  inverse: false,
};
Vue.use(VueRouter);
Vue.use(VueFilter);
Vue.use(VueMoment);
Vue.use(VueProgressBar, ProgressBarOptions);
Vue.use(ElementUI, { locale });

// Auth.checkAuth()
Vue.component('masked-input', MaskedInput);
Vue.component('zee-sidebar-menu', SidebarMenu);
Vue.component('zee-topbar-menu', TopbarMenu);
Vue.filter('currency', currency);
Vue.filter('capitalize', capitalize);
Vue.filter('number', number);

new Vue({ // eslint-disable-line no-new
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js